<template>
  <div class="document-config">
    <!-- 搜索条件 -->
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form" size="small">
      <el-form-item prop="configName">
        <el-input clearable v-model="searchForm.configName" placeholder="名称" />
      </el-form-item>

      <el-form-item prop="configKey">
        <el-input clearable v-model="searchForm.configKey" placeholder="配置标识" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('searchForm')">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <div class="table-container">
      <div class="table-header">
        <p class="total-count">总数: {{ total }}</p>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleEdit(1)">新增</el-button>
      </div>
      <el-table class="table-list" :data="tableData" border :stripe="true" :show-overflow-tooltip="true">
        <el-table-column type="index" align="center" label="序号" />
        <el-table-column align="center" prop="configName" label="名称" min-width="160" />
        <el-table-column align="center" prop="description" label="描述" min-width="160" />
        <el-table-column align="center" prop="configKey" label="配置标识" min-width="120" />
        <el-table-column align="center" prop="category" label="分类" width="140" />
        <el-table-column align="center" prop="valueType" label="内容数据类型" width="140" />
        <el-table-column align="center" label="内容" min-width="240">
          <template slot-scope="scope">
            <div class="content">{{ scope.row.configValue }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isDisabled ? 'danger' : 'success'">{{ scope.row.isDisabled ? "禁用" : "启用" }}</el-tag>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(2, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="changeStatus(scope.row)">{{ scope.row.isDisabled ? "启用" : "禁用" }}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="footer">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="searchForm.size"
        @current-change="handleCurrentChange"
        @size-change="onChangesize"
        :current-page="searchForm.current"
      ></el-pagination>
    </div>

    <!-- 编辑弹窗 -->
    <editDocument :editDocumentShow="editDocumentShow" :editType="editType" :id="documentId" @close="close"></editDocument>
  </div>
</template>

<script>
import editDocument from "./editDocument.vue";
import { getDocumentConfigList, deleteDocumentConfig, updateDocumentConfigStatus } from "@/api/basicConfig";

export default {
  components: {
    editDocument
  },
  data() {
    return {
      searchForm: {
        configName: "",
        configKey: "",
        current: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      editType: 1, // 编辑类型 1:新增 2:编辑
      documentId: "", // id
      editDocumentShow: false // 编辑banner弹窗是否显示
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    // 初始化
    init() {
      this.getDocumentList();
    },

    // 获取列表
    async getDocumentList() {
      try {
        let res = await getDocumentConfigList(this.searchForm);
        if (res.code == 200) {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 查询
    handleQuery() {
      this.searchForm.current = 1;
      this.getDocumentList();
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.searchForm.current = 1;
      this.getDocumentList();
    },

    // 页码改变
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getDocumentList();
    },

    // 每页条数改变
    onChangesize(val) {
      this.searchForm.size = val;
      this.searchForm.current = 1;
      this.getDocumentList();
    },

    // 编辑banner
    handleEdit(type, row) {
      if (type == 1) {
        this.documentId = "";
        this.editType = 1;
      } else if (type == 2) {
        this.editType = 2;
        this.documentId = row.id || "";
      }
      this.editDocumentShow = true;
    },

    // 关闭编辑banner弹窗
    close() {
      this.documentId = "";
      this.editDocumentShow = false;
      this.getDocumentList();
    },

    changeStatus(row) {
      this.$confirm(`确认${row.isDisabled ? "启用" : "禁用"}配置项?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.onChangeStatus(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },

    // 切换状态
    async onChangeStatus(row) {
      try {
        let res = await updateDocumentConfigStatus({ id: row.id });
        if (res.code == 200) {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.getDocumentList();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确认删除配置项?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.onDelete(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 删除
    async onDelete(row) {
      try {
        let res = await deleteDocumentConfig({ id: row.id });
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getDocumentList();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.document-config {
  padding: 20px;
}

.table-container {
  padding: 10px 20px 20px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 72px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .total-count {
    font-size: 18px;
    font-weight: 600;
  }
}

.table-list {
  font-size: 12px;

  .content {
    // 超出部分省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.footer {
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 100;
  padding: 20px;
  box-shadow: 0 -8px 8px -10px rgba(0, 0, 0, 0.2);
  /* 顶部外阴影 */

  .pagination {
    text-align: right;
    padding: 0;
  }
}
</style>
